import { Polygon } from '@react-google-maps/api';
import React from 'react';
import {
	isDesktop
} from "react-device-detect";
import MuiAlert from '@material-ui/lab/Alert';
import { useActions, useValues } from 'kea';
import geofencelogic from 'src/store/geofence';
import { maplogic } from 'src/store/global';
import { Portal, Snackbar } from '@material-ui/core';
import checkRole from 'src/utils/checkRole';
import profilelogic from 'src/store/profile';
// let drawnGeofences = [];

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function DrawGeofence() {
	const { geofencesOnMap: geofences, onMap } = useValues(geofencelogic);
	const { update, fetchAll: geofenceFetchAll } = useActions(geofencelogic);

	const { setUpdatePosition } = useActions(maplogic);

	const [drawnGeofences, setDrawnGeofences] = React.useState({});
	const [snackbarOpen, setSnackbarOpen] = React.useState(0);
	const { profile } = useValues(profilelogic);

	React.useEffect(() => {
		geofences ?? geofenceFetchAll();
	}, []) // eslint-disable-line

	// React.useEffect(() => {
	// console.log(drawnGeofences);
	// }, [drawnGeofences])

	const handleUpdate = async (existingGeofence) => {
		await update(existingGeofence);
	}


	const onClick = async (_item, id) => {
		if (isDesktop) {
			if (drawnGeofences[id].getEditable()) {
				// console.log(drawnGeofences[id].getPaths().getArray())
				const new_polygon = [drawnGeofences[id].getPath().getArray().map((item) => {
					return [item.lng(), item.lat()]
				})]
				let updated_geofence = geofences.find(g => g._id === id);
				// console.log(new_polygon, updated_geofence.polygon.coordinates)
				updated_geofence.polygon.coordinates = new_polygon;
				await handleUpdate(updated_geofence);
				setUpdatePosition(true);
				drawnGeofences[id].setEditable(false);
				drawnGeofences[id].setDraggable(false);
				// setTimeout(() => handleSnackOpen(snackbarOpen - 1), 1000);
				setSnackbarOpen(snackbarOpen - 1)
				// console.log(new_polygon);
			} else {
				setUpdatePosition(false);
				drawnGeofences[id].setEditable(true);
				drawnGeofences[id].setDraggable(true);
				setSnackbarOpen(snackbarOpen + 1);
			}
			// setSelected(index);
		}
	}



	// useEffect(()=>{
	// 	if(selected){
	// 		drawnGeofences[selected].setOptions({...geofences[selected].polygon.properties, strokeWeight:6});
	// 	}
	// },[selected])

	const onMouseOver = (_item, id) => {
		if (isDesktop) {
			// drawnGeofences[index]
			drawnGeofences[id].setOptions({ ...geofences.find(g => g._id === id).polygon.properties, strokeWeight: 6 });
			// console.log('over: ', drawnGeofences[index].setOptions({...geofences[index].polygon.properties, strokeWeight:5}));
			drawnGeofences[id].setOptions({ ...geofences.find(g => g._id === id).polygon.properties, strokeWeight: 6 });
		}
	}

	const onMouseOut = (_item, id) => {
		// console.log(drawnGeofences)
		if (isDesktop) {
			// drawnGeofences[index]
			drawnGeofences[id].setOptions({ ...geofences.find(g => g._id === id).polygon.properties, strokeWeight: 3 });
			// console.log('out: ', drawnGeofences[index].setOptions());
			drawnGeofences[id].setOptions({ ...geofences.find(g => g._id === id).polygon.properties, strokeWeight: 3 });
		}
	}

	const onLoad = (e, id) => {
		// setDrawnGeofences([...drawnGeofences, e]);
		drawnGeofences[id] = e;
		// console.log(e.getPath().getArray())
	}

	const onUnmount = (e, id) => {
		// let tmp = [...drawnGeofences];
		// tmp.splice(id, 1);
		// setDrawnGeofences(tmp);
		delete drawnGeofences[id];
	}

	if (geofences === null || geofences === undefined) {
		return <></>;
	}

	return (<>
		<Portal>
			<Snackbar open={snackbarOpen > 0 && checkRole(profile, ['GeofenceEdit'])} >
				<Alert severity="info">
					Editing a geofence.
				</Alert>
			</Snackbar>
		</Portal>
		{geofences.map((item, index) => {
			const paths = item.polygon.coordinates[0].map(pos => {
				return {
					lng: pos[0],
					lat: pos[1]
				}
			})
			// console.log('index', item)
			return (
				<Polygon
					onClick={() => onClick(item, item._id)}
					onMouseOver={() => onMouseOver(item, item._id)}
					onMouseOut={() => onMouseOut(item, item._id)}
					onLoad={(e) => onLoad(e, item._id)}
					paths={paths}
					onUnmount={(e) => onUnmount(e, item._id)}
					options={item.polygon.properties}
				/>
			)
		})}
	</>
	)
}

export default DrawGeofence;